module.exports = __webpack_public_path__ + "img/ft-color.497206a1.svg";